/**
 * Save Story for Instagram
 *
 * Declares its web-accessible resources as globs — `/img/*.svg` and `/fonts/*.ttf` on
 * `<all_urls>` — which the auto-generator skips because a wildcard can't be probed. But
 * the directory ships stable, vendor-named files, and any one of them is reachable from
 * any origin at a fixed URL, so a single request is conclusive.
 *
 * `img/iconHeart.svg` and `fonts/Inter_Regular.ttf` are the probed paths.
 *
 * Manifest verified against version 1.8.2.
 */

import { probeImage, probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'lknpbgnookklokdjomiildnlalffjmma';

export const saveStoryInstagram: ExtensionDefinition = {
  id: ID,
  name: 'Save Story for Instagram',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 100_000,
  notes:
    'Web-accessible resources declared as /img/*.svg and /fonts/*.ttf on <all_urls>. ' +
    'The glob is unprobeable, but the shipped files are stable and reachable from any ' +
    'origin, so a single request identifies the extension.',
  signals: [
    {
      id: 'war-icon-heart-svg',
      kind: 'web-accessible-resource',
      description:
        'Load img/iconHeart.svg — a stable, vendor-named web-accessible resource exposed ' +
        'on <all_urls>.',
      weight: 1,
      run: () => probeImage(ID, 'img/iconHeart.svg'),
    },
    {
      id: 'war-inter-regular-ttf',
      kind: 'web-accessible-resource',
      description: 'Fetch fonts/Inter_Regular.ttf — a second shipped web-accessible file.',
      weight: 0.5,
      run: () => probeFetch(ID, 'fonts/Inter_Regular.ttf'),
    },
  ],
};
